import { createSelector } from 'reselect';

const getSettings = state => state.settingsList.data;

const getSettingByName = name =>
  createSelector(
    getSettings,
    settings => settings && settings.find(setting => setting.name === name)
  );

// https://github.com/reduxjs/reselect#q-how-do-i-create-a-selector-that-takes-an-argument
const getTimeoutDuration = createSelector(
  getSettingByName('timeout'),
  setting => setting && setting.value
);

export { getSettings, getTimeoutDuration };



// WEBPACK FOOTER //
// ./src/selectors/settings.js